import '~/js/modules/stickyNav';

const $tabSelects = $('#js-tab-select');
const $context = $('[data-init="map"]');
const $navigation = $('.map-controls-list', $context);
const $captions = $('#default-captions', $context);

function menuHandler(e) {
    e.preventDefault();
    const target = $(this).attr('href');

    $('a', $context).not(this).parent('li').removeClass('active');
    $(this).parent('li').toggleClass('active');
    $('.markers-group', $context).not(target).removeClass('active');
    $(target).toggleClass('active');
    $tabSelects.val(target);
    $tabSelects.selectmenu('refresh');
    const isDisplayDefaults = $('.active', $navigation).length > 0;

    isDisplayDefaults ? $captions.removeClass('active') : $captions.addClass('active');
}

function selectHandler(e, { item }) {
    $('li', $context).removeClass('active');
    $('a[href="' + item.value + '"]').parent('li').addClass('active');
    $('.markers-group', $context).removeClass('active');
    $(item.value).addClass('active');
    const isDisplayDefaults = $('.active', $navigation).length > 0;

    isDisplayDefaults ? $captions.removeClass('active') : $captions.addClass('active');

    if(item.value) {
        //  console.log(item.value);
    }
}

$('a', $navigation).on('click', menuHandler);

$tabSelects.selectmenu({
    appendTo: $tabSelects.parent(),
    select: selectHandler
});
